import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useCustomerConfigSync, useInvalidateCustomerCache, } from '@planter/common';
/**
 * Componente che sincronizza il config del customer con Redux (versione Web).
 * Quando il tab torna visibile forza il refetch del Customer per rilevare aggiornamenti
 * del JWT customer config (nuove feature flag, schema bump) senza richiedere logout/restart.
 */
export var CustomerConfigSync = function (_a) {
    var children = _a.children;
    useCustomerConfigSync();
    var invalidateCustomer = useInvalidateCustomerCache();
    useEffect(function () {
        var onVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                invalidateCustomer();
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return function () {
            return document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [invalidateCustomer]);
    return _jsx(_Fragment, { children: children });
};
